import { render, staticRenderFns } from "./repaymentPay.vue?vue&type=template&id=20f573f7&scoped=true"
import script from "./repaymentPay.vue?vue&type=script&lang=js"
export * from "./repaymentPay.vue?vue&type=script&lang=js"
import style0 from "./repaymentPay.vue?vue&type=style&index=0&id=20f573f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f573f7",
  null
  
)

export default component.exports